const Faqs = [
  {
    id: 4547,
    title: "Which payment options do you offer?",
    content:
      "<p>We accept payments by credit card, Ideal, bank transfers and many other popular payment methods which are accepted in your country.</p><p></p>",
  },
  {
    id: 1734,
    title: "How does Budget Fit Plan stand out from other nutrition programs?",
    content:
      "<p>What makes us unique is the combination of:</p>\n<p>Scientifically backed recommendations.<br />\nExpertise from leading nutrition and diet specialists.<br />\nPractical, affordable, and easy-to-prepare meals.<br />\nPersonalized adjustments based on your preferences and goals.<br />\nContinuous support and smart tools to maximize your success.</p>\n",
  },
  {
    id: 1733,
    title: "Can I still enjoy my favorite foods?",
    content:
      "<p>Definitely! Our goal is to create a diet that is both healthy and enjoyable. We offer smart alternatives and modifications so you can enjoy delicious meals without guilt. It’s all about balance and making conscious choices.</p>\n",
  },
  {
    id: 1732,
    title: "How can I be sure that the advice will work for me?",
    content:
      "<p>Our advice has already been successfully applied by thousands of people. We combine scientific evidence with practical application and give you the flexibility to make choices that suit you. Additionally, we provide guidance and smart tools to track your progress and achieve your goals.</p>\n",
  },
  {
    id: 1731,
    title: "Are the meal plans practical and achievable?",
    content:
      "<p>Absolutely! We understand that a meal plan only works if it is practical and easy to follow. That’s why our meals are not only healthy and balanced but also simple to prepare and affordable. We take into account your daily routine, cooking skills, and available time.</p>\n",
  },
  {
    id: 1730,
    title: "Is the advice suitable for everyone?",
    content:
      "<p>Our advice is personalized and tailored to your specific goals, preferences, and lifestyle. Whether you want to lose weight, build muscle, or maintain a healthy lifestyle, Budget Fit Plan provides customized recommendations that fit your needs.</p>\n",
  },
  {
    id: 1729,
    title: "Is the advice backed by scientific research?",
    content:
      "<p>Yes, all our nutrition advice is based on the latest scientific insights. We follow the guidelines of renowned nutrition institutes and dietitians to ensure that our recommendations are effective, safe, and sustainable.</p>\n",
  },
  {
    id: 1728,
    title: "How reliable is the nutrition advice within Budget Fit Plan?",
    content:
      "<p>Our nutrition advice is based on the extensive expertise of the world&#8217;s best nutrition and diet specialists. These recommendations have been carefully compiled using scientific research and practical experience. They are not only theoretically sound but have also been extensively proven in real-life situations by thousands of people who have successfully achieved their health goals.</p>\n",
  },
  {
    id: 1727,
    title: "How does Budget Fit Plan stand out from other exercise programs?",
    content:
      "<p>What makes us unique is the combination of:</p>\n<p>Scientifically proven exercise methods.<br />\nExpertise from top fitness and movement specialists.<br />\nWorkouts that are easy to follow, effective, and require minimal equipment.<br />\nCustomization based on your fitness level, goals, and preferences.<br />\nTime-efficient workouts designed for busy schedules.<br />\nContinuous support and tracking tools to keep you motivated.</p>\n",
  },
  {
    id: 1726,
    title: "Can I still see results if I have little time to work out?",
    content:
      "<p>Yes! Our programs include time-efficient workouts that deliver maximum results per day. We focus on smart training strategies that help you burn calories, strengthen muscles, and improve endurance without long workout sessions.</p>\n",
  },
  {
    id: 1725,
    title: "Do I need a gym membership to follow the workouts?",
    content: "",
  },
  {
    id: 1724,
    title: "How can I be sure that the recommended exercises will work for me?",
    content:
      "<p>Our exercise programs are based on tested and proven movement principles. Thousands of people have already used our routines to improve their fitness, burn fat, and build strength. We also provide guidance and progress tracking so you can see real improvements over time.</p>\n",
  },
  {
    id: 1723,
    title: "Are the workouts practical and easy to follow?",
    content:
      "<p>Absolutely! We understand that effective workouts must fit into a busy lifestyle. That’s why our exercise programs are designed to be time-efficient, easy to follow at home or in the gym, and require little to no special equipment. You’ll always find exercises that match your daily routine.</p>\n",
  },
  {
    id: 1722,
    title: "Are the workouts suitable for everyone?",
    content:
      "<p>Our exercises are fully tailored to different fitness levels, body types, and personal goals. Whether you are a beginner, returning to exercise after a break, or an experienced athlete, Budget Fit Plan provides a structured approach that fits your needs and progress level.</p>\n",
  },
  {
    id: 1721,
    title: "Are the exercises scientifically backed?",
    content:
      "<p>Yes, all our exercise routines are based on the latest scientific findings in sports science, biomechanics, and physical health. We work with proven training methods that are safe, effective, and designed to deliver results without unnecessary strain on the body.</p>\n",
  },
  {
    id: 1720,
    title:
      "How reliable are the exercise recommendations within Budget Fit Plan?",
    content:
      "<p>Our exercise recommendations are based on the extensive expertise of the world&#8217;s best fitness and movement specialists. These workouts have been carefully developed using scientific research and years of real-world application. They are not only proven effective in theory but have also been successfully implemented by thousands of people to improve their fitness, strength, and overall health.</p>\n",
  },
  {
    id: 1514,
    title: "Where can I find FitBot in the app?",
    content:
      "<p>In your <strong>dashboard—just start chatting whenever you need help!</strong></p>",
  },
  {
    id: 1513,
    title: "Is FitBot available anytime?",
    content: "<p>Yes! <strong>24/7, always ready to assist you</strong>.</p>",
  },
  {
    id: 1512,
    title: "Can I ask FitBot for quick sleep hacks?",
    content:
      "<p>Yes! Get <strong>fast, effective sleep improvement tips instantly</strong>.</p>\n",
  },
  {
    id: 1511,
    title: "Does FitBot offer real-time hydration tips?",
    content:
      "<p>Yes! It <strong>reminds you when to drink water and stay hydrated</strong>.</p>\n",
  },
  {
    id: 1510,
    title: "Can FitBot answer mindfulness questions?",
    content:
      "<p>Yes! It gives <strong>breathing techniques, relaxation exercises, and mental wellness tips</strong>.</p>\n",
  },
  {
    id: 1509,
    title: "How does FitBot help with motivation?",
    content:
      "<p>It provides <strong>encouraging messages, goal-setting support, and instant tips</strong>.</p>\n",
  },
  {
    id: 1508,
    title: "Can FitBot track my progress?",
    content:
      "<p>Yes, it <strong>monitors your fitness, weight, hydration, and habits</strong>.</p>\n",
  },
  {
    id: 1507,
    title: "Does FitBot help with food choices?",
    content:
      "<p>Yes! FitBot <strong>suggests healthy alternatives and meal swaps</strong>.</p>\n",
  },
  {
    id: 1506,
    title: "Can FitBot recommend workouts?",
    content:
      "<p>Yes! Ask for <strong>customized exercises based on your fitness level and goals</strong>.</p>\n",
  },
  {
    id: 1505,
    title: "What is FitBot?",
    content:
      "<p>FitBot is your <strong>24/7 AI personal guide</strong> for instant advice on fitness, food, sleep, and wellness.</p>\n",
  },
  {
    id: 1504,
    title: "Can quizzes help track progress?",
    content:
      "<p>Yes! They <strong>assess knowledge, habits, and personal growth</strong>.</p>\n",
  },
  {
    id: 1503,
    title: "Are there rewards for completing quizzes?",
    content:
      "<p>Yes! Earn <strong>badges, points, and motivation boosts</strong>.</p>\n",
  },
  {
    id: 1502,
    title: "How often are new quizzes added?",
    content:
      "<p>Daily! <strong>Stay engaged with fresh, informative challenges</strong>.</p>\n",
  },
  {
    id: 1501,
    title: "Do quizzes give personalized advice?",
    content:
      "<p>Yes! <strong>Your answers shape recommendations for better habits</strong>.</p>\n",
  },
  {
    id: 1500,
    title: "What kind of quizzes are included?",
    content:
      "<p>Fun, interactive quizzes on <strong>nutrition, fitness, hydration, sleep, and mindfulness</strong>.</p>\n",
  },
  {
    id: 1499,
    title: "Do meals include high-protein options?",
    content:
      "<p>Yes! Great for <strong>muscle building, metabolism boost, and satiety</strong>.</p>\n<p>&nbsp;</p>\n",
  },
  {
    id: 1498,
    title: "Can I see nutritional information for meals?",
    content:
      "<p>Yes! Each meal <strong>shows calories, macronutrients, and portion sizes</strong>.</p>\n",
  },
  {
    id: 1497,
    title: "Are meals affordable?",
    content:
      "<p>Yes! Recipes focus on <strong>budget-friendly ingredients</strong>.</p>\n",
  },
  {
    id: 1496,
    title: "Can I get meal suggestions based on cravings?",
    content:
      "<p>Yes! Get <strong>healthy alternatives when craving sweets, salty foods, or comfort meals</strong>.</p>\n",
  },
  {
    id: 1495,
    title: "Do meal plans include snacks?",
    content:
      "<p>Yes! Enjoy <strong>healthy snack ideas that fit your plan</strong>.</p>\n",
  },
  {
    id: 1494,
    title: "Are recipes family-friendly?",
    content:
      "<p>Yes! Meals are <strong>balanced, tasty, and adaptable for the whole family</strong>.</p>\n",
  },
  {
    id: 1493,
    title: "Can I plan meals around my schedule?",
    content:
      "<p>Yes! Choose <strong>quick meals for busy days or slow-cooked meals for weekends</strong>.</p>\n",
  },
  {
    id: 1492,
    title: "Are recipes easy to follow?",
    content:
      "<p>Yes! Each recipe includes <strong>simple steps, cooking time, and ingredient swaps</strong>.</p>\n",
  },
  {
    id: 1491,
    title: "Can I meal prep for the week?",
    content:
      "<p>Yes! Get <strong>time-saving food prepping tips and batch-cooking guides</strong>.</p>\n",
  },
  {
    id: 1490,
    title: "Are there ready-made shopping lists?",
    content:
      "<p>Yes! The app <strong>automatically creates your shopping list based on your meal plan</strong>.</p>\n",
  },
  {
    id: 1489,
    title: "Can I combine mindfulness with workouts?",
    content:
      "<p>Yes! Try <strong>mindful movement, yoga, and breathwork during exercise</strong>.</p>\n",
  },
  {
    id: 1488,
    title: "What if I’ve never practiced mindfulness before?",
    content:
      "<p>No problem! <strong>Start with simple, guided exercises</strong> tailored for beginners.</p>\n",
  },
  {
    id: 1487,
    title: "Does mindfulness help reduce stress?",
    content:
      "<p>Yes, it lowers <strong>cortisol (stress hormone) levels</strong> and promotes calmness.</p>\n",
  },
  {
    id: 1486,
    title: "Can mindfulness improve my sleep?",
    content:
      "<p>Yes, <strong>relaxation techniques help you unwind for better sleep</strong>.</p>\n",
  },
  {
    id: 1485,
    title: "How long do mindfulness sessions take?",
    content:
      "<p>Just <strong>5-10 minutes a day</strong> for a calmer mind and body.</p>\n",
  },
  {
    id: 1484,
    title: "Are guided meditations included?",
    content:
      "<p>Yes, with <strong>audio and video options for relaxation and focus</strong>.</p>\n",
  },
  {
    id: 1483,
    title: "Can I track my mindfulness progress?",
    content:
      "<p>Yes! Log <strong>mindfulness sessions and emotional well-being in the app</strong>.</p>\n",
  },
  {
    id: 1482,
    title: "Are there daily mindfulness exercises?",
    content:
      "<p>Yes, including <strong>breathing exercises, gratitude journaling, and short guided meditations</strong>.</p>\n",
  },
  {
    id: 1481,
    title: "How does mindfulness help with weight loss?",
    content:
      "<p>It helps <strong>control cravings, reduce emotional eating, and increase awareness of hunger signals</strong>.</p>\n",
  },
  {
    id: 1480,
    title: "What is the Mindfulness Plan?",
    content:
      "<p>A step-by-step <strong>mental well-being program</strong> to improve focus, reduce stress, and boost happiness.</p>\n",
  },
  {
    id: 1479,
    title: "Does FitBot help with sleep advice?",
    content:
      "<p>Yes, <strong>ask FitBot 24/7 for personalized sleep improvement tips</strong>.</p>\n",
  },
  {
    id: 1478,
    title: "Can I combine sleep coaching with mindfulness?",
    content:
      "<p>Absolutely! <strong>Relaxation exercises and mindfulness improve sleep quality</strong>.</p>\n",
  },
  {
    id: 1477,
    title: "Are there power nap guidelines?",
    content:
      "<p>Yes! Learn how to <strong>use naps effectively for energy without grogginess</strong>.</p>\n",
  },
  {
    id: 1476,
    title: "Can sleep tracking improve my weight loss results?",
    content:
      "<p>Yes! Good sleep <strong>supports metabolism, reduces cravings, and boosts energy</strong>.</p>\n",
  },
  {
    id: 1475,
    title: "What if I struggle with waking up early?",
    content:
      "<p>The app provides <strong>morning energy-boosting tips and gentle wake-up routines</strong>.</p>\n",
  },
  {
    id: 1474,
    title: "Are there tips for improving deep sleep?",
    content:
      "<p>Yes, with advice on <strong>bedtime habits, blue light exposure, and relaxation</strong>.</p>\n",
  },
  {
    id: 1473,
    title: "Can I set a bedtime reminder?",
    content:
      "<p>Yes, the app <strong>reminds you when to start your nighttime routine</strong>.</p>\n",
  },
  {
    id: 1472,
    title: "Does the app offer bedtime relaxation exercises?",
    content:
      "<p>Yes! Try <strong>evening yoga, guided sleep meditations, and breathing techniques</strong>.</p>\n",
  },
  {
    id: 1471,
    title: "Can I track my sleep in the app?",
    content:
      "<p>Yes, you can <strong>log sleep duration, quality, and bedtime habits.</strong></p>\n",
  },
  {
    id: 1470,
    title: "What is the Sleep Coaching feature?",
    content:
      "<p>A <strong>personalized plan to improve sleep quality, fall asleep faster, and wake up refreshed</strong>.</p>\n",
  },
  {
    id: 1469,
    title: "Are there guides for stress-free mornings?",
    content:
      "<p>Yes! Learn <strong>morning routines that set you up for success</strong>.</p>\n",
  },
  {
    id: 1468,
    title: "What happens if I forget a daily goal?",
    content:
      "<p>The app sends <strong>gentle reminders</strong> to keep you on track.</p>\n",
  },
  {
    id: 1467,
    title: "Are the lifestyle plans time-consuming?",
    content:
      "<p>No! They are <strong>simple, effective, and take just a few minutes a day</strong>.</p>\n",
  },
  {
    id: 1466,
    title: "Can I adjust my lifestyle plan later?",
    content:
      "<p>Yes, switch plans <strong>whenever you need</strong> a new focus.</p>\n",
  },
  {
    id: 1465,
    title: "How do lifestyle plans support my goals?",
    content:
      "<p>They help you <strong>build long-term habits for better sleep, mood, energy, and focus</strong>.</p>\n",
  },
  {
    id: 1464,
    title: "Are there stress-reduction tools?",
    content:
      "<p>Yes! Use <strong>breathing exercises, guided meditations, and relaxation tips</strong>.</p>\n",
  },
  {
    id: 1463,
    title: "Can I set daily wellness goals?",
    content:
      "<p>Yes! Choose goals for <strong>hydration, relaxation, mindfulness, and step count</strong>.</p>\n",
  },
  {
    id: 1462,
    title: "How does the Motivation Coach help me?",
    content:
      "<p>You get <strong>daily motivational tips, affirmations, and goal reminders</strong> to stay inspired.</p>\n",
  },
  {
    id: 1461,
    title: "Can I choose a lifestyle plan?",
    content:
      "<p>Yes! Select a <strong>sleep, mindfulness, food, energy, hydration, or movement plan</strong> that fits your needs.</p>\n",
  },
  {
    id: 1460,
    title: "What are Lifestyle Plans?",
    content:
      "<p>Small, easy-to-follow plans to <strong>improve sleep, reduce stress, build habits, increase energy, or boost daily activity</strong>.</p>\n",
  },
  {
    id: 1459,
    title: "How do I reset my password?",
    content:
      "<p>Reset it <strong>via email in the login section</strong>.</p>\n",
  },
  {
    id: 1458,
    title: "Is customer support available?",
    content:
      "<p>Yes, <strong>contact us via in-app chat on our contact page or ask all your questions to your personalized FitBot!</strong></p>\n",
  },
  {
    id: 1457,
    title: "Does the app have push notifications?",
    content:
      "<p>Yes! Get <strong>meal, workout, hydration, and mindfulness reminders</strong>.</p>\n",
  },
  {
    id: 1456,
    title: "Is the app available on iOS and Android?",
    content:
      "<p>Yes, <strong>download it from the App Store or Google Play</strong>.</p>\n",
  },
  {
    id: 1455,
    title: "Can I sync the app with a smartwatch?",
    content:
      "<p>Yes, it works with <strong>Fitbit, Apple Watch, and more</strong>.</p>\n",
  },
  {
    id: 1454,
    title: "Is there food prep guidance in the community?",
    content:
      "<p>Yes! Members <strong>share meal-prep tips and hacks</strong>.</p>\n",
  },
  {
    id: 1453,
    title: "Are there weekly challenges?",
    content:
      "<p>Yes! Join the <strong>weekly exercise  and mindfulness challenges</strong>.</p>\n",
  },
  {
    id: 1452,
    title: "Can I interact with coaches?",
    content:
      "<p>Yes, through the <strong>community and FitBot chat</strong>.</p>\n",
  },
  {
    id: 1451,
    title: "Are there interactive quizzes?",
    content:
      "<p>Yes! Fun quizzes <strong>help you learn about fitness, sleep, and healthy habits</strong>.</p>\n",
  },
  {
    id: 1450,
    title: "What is the Budget Fit Plan community?",
    content:
      "<p>A <strong>supportive space</strong> for sharing <strong>tips, success stories, and motivation</strong>.</p>\n",
  },
  {
    id: 1449,
    title: "Are shopping lists included?",
    content:
      "<p>Yes! <strong>Automated shopping lists</strong> make meal planning easier.</p>\n",
  },
  {
    id: 1448,
    title: "Does the app track hydration?",
    content:
      "<p>Yes! You get <strong>personalized water intake reminders</strong>.</p>\n",
  },
  {
    id: 1447,
    title: "Can I track mood and energy?",
    content:
      "<p>Yes! Log your <strong>energy levels and emotional well-being</strong> daily.</p>\n",
  },
  {
    id: 1446,
    title: "How does FitBot help me?",
    content:
      "<p><strong>FitBot is your 24/7 personal guide</strong>, answering questions and giving <strong>instant motivation</strong>.</p>\n",
  },
  {
    id: 1445,
    title: "What progress tracking tools are included?",
    content:
      "<p>Track <strong>weight, hydration, sleep, activity, mindfulness, and fitness improvements</strong>.</p>\n",
  },
  {
    id: 1444,
    title: "Are short workouts available?",
    content:
      "<p>Yes! <strong>10-minute express workouts</strong> are included.</p>\n",
  },
  {
    id: 1443,
    title: "Can I track my workout progress?",
    content:
      "<p>Yes! Track your <strong>steps, activity, strength gains, and endurance improvements</strong>.</p>\n",
  },
  {
    id: 1442,
    title: "Can I do workouts for better sleep?",
    content:
      "<p>Yes! <strong>Evening yoga and relaxation workouts</strong> help improve sleep quality.</p>\n",
  },
  {
    id: 1441,
    title: "What types of workouts are included?",
    content:
      "<p>In your <strong>personal settings you can specify in detail which sports and workouts you prefer. A lot is possible!</strong></p>\n",
  },
  {
    id: 1440,
    title: "Do I need a gym membership?",
    content:
      "<p>No! Home workouts, outdoor exercises, <strong>yoga, relaxation workouts</strong> and lots lots more exercises are included.</p>\n",
  },
  {
    id: 1439,
    title: "Can I follow a small lifestyle plan?",
    content:
      "<p>Yes! Choose a <strong>lifestyle plan</strong> to focus on <strong>better habits, self-care, or energy boosting</strong>.</p>\n",
  },
  {
    id: 1438,
    title: "Does the plan help with stress?",
    content:
      "<p>Yes, <strong>mindfulness exercises and relaxation techniques</strong> are included!</p>\n",
  },
  {
    id: 1437,
    title: "Do I get food prepping tips?",
    content:
      "<p>Yes! <strong>Smart meal prep tips</strong> save time and make <strong>healthy eating easier</strong>.</p>\n",
  },
  {
    id: 1436,
    title: "Is hydration tracking included?",
    content:
      "<p>Yes! Set daily <strong>water intake goals</strong> and receive reminders.</p>\n",
  },
  {
    id: 1435,
    title: "Can I follow a sleep improvement plan?",
    content:
      "<p>Yes! Our <strong>sleep coaching tools</strong> help you <strong>fall asleep faster and wake up refreshed</strong>.</p>\n",
  },
  {
    id: 1434,
    title: "Does the plan include mindfulness?",
    content:
      "<p>Yes! A <strong>step-by-step mindfulness plan</strong> is included to <strong>reduce stress and improve focus</strong>.</p>\n",
  },
  {
    id: 1433,
    title: "What if I have food allergies?",
    content:
      "<p>You can <strong>exclude allergens</strong> and get a <strong>customized meal plan</strong>.</p>\n",
  },
  {
    id: 1432,
    title: "Can I change my plan later?",
    content:
      "<p>Yes, you can <strong>adjust your workouts, meals, hydration goals, and mindfulness settings anytime</strong>.</p>\n",
  },
  {
    id: 1431,
    title: "Can I choose my meals?",
    content:
      "<p>Yes! <strong>For each menu (breakfast, lunch and dinner) you receive 3 alternatives to choose from!</strong></p>\n<p>&nbsp;</p>\n",
  },
  {
    id: 1430,
    title: "How is my plan created?",
    content:
      "<p>Based on your <strong>goals, sleep habits, food preferences, lifestyle needs, and wellness choices</strong>.</p>\n<p>&nbsp;</p>\n<p>&nbsp;</p>\n",
  },
  {
    id: 1429,
    title: "Are there any limitations in the trial?",
    content:
      "<p>No! <strong>Full access</strong> to meals, workouts, progress tools, sleep coaching, and FitBot!</p>\n",
  },
  {
    id: 1428,
    title: "Can I cancel during the trial?",
    content:
      "<p>Yes! <strong>Cancel anytime before your trial ends</strong>, and you <strong>won’t be charged</strong>.</p>\n",
  },
  {
    id: 1427,
    title: "What happens after my trial?",
    content:
      "<p>Your <strong>subscription automatically starts</strong> at <strong>€12 per month</strong>, including <strong>everything</strong>.</p>\n",
  },
  {
    id: 1426,
    title: "Do I need payment details for the trial?",
    content:
      "<p>Yes, but you <strong>won’t be charged if you cancel before your trial ends</strong>.</p>\n",
  },
  {
    id: 1425,
    title: "Is there a free trial?",
    content:
      "<p>Yes! <strong>Enjoy full access</strong> to workouts, lifestyle plans, mindfulness, meal plans, hydration tracking, and FitBot for <strong>one free week</strong>.</p>\n",
  },
  {
    id: 1424,
    title: "Can I pay yearly instead of 4 week basis?",
    content:
      "<p>Currently, we <strong>only offer 4 week basis billing</strong> for flexibility.</p>\n<p>&nbsp;</p>\n",
  },
  {
    id: 1422,
    title: "How do I sign up?",
    content:
      "<p>Click on the &#8220;Get Started Now&#8221; button in the menu, create an account, choose your<br />preferences, and start!</p>\n",
  },
  {
    id: 1421,
    title: "Is Budget Fit Plan a subscription?",
    content:
      "<p>Yes, it’s a  4 week basis subscription, but you can cancel anytime.</p>\n",
  },
  {
    id: 1420,
    title: "Can I cancel anytime?",
    content:
      "<p>Yes, cancel anytime through your profile settings with no long-term<br />commitment.</p>\n",
  },
  {
    id: 1419,
    title: "Are there any extra costs?",
    content:
      "<p>No hidden fees—recipes, All premium features are included!</p>\n",
  },
  {
    id: 1418,
    title: "How much does Budget Fit Plan cost?",
    content:
      "<p>€3 per week, billed 4 weekly (€12 per 4 weeks)—including everything<br />from coaching to FitBot guidance!</p>\n",
  },
  {
    id: 1417,
    title: "Do I need to be fit to start?",
    content:
      "<p>Not at all! We adapt to any fitness level and include gentle<br />movement, mindfulness, and small lifestyle plans.</p>\n",
  },
  {
    id: 1416,
    title: "Who can join Budget Fit Plan?",
    content:
      "<p>Anyone who wants to improve their health, lose weight, boost energy, sleep better, or adopt a mindful lifestyle.</p>\n",
  },
  {
    id: 1415,
    title: "How does Budget Fit Plan help me lose weight?",
    content:
      "<p>With custom meal plans, exercise, hydration tracking, sleep<br />coaching, mindfulness, and motivation, ensuring a balanced<br />approach to lasting weight loss.</p>\n",
  },
  {
    id: 1414,
    title: "What is Budget Fit Plan?",
    content:
      "<p>A personalized health and wellness platform offering meal plans,<br />workouts, lifestyle coaching, sleep support, mindfulness, hydration<br />plans, quizzes, and a 24/7 FitBot Guide!</p>\n",
  },
];
export default Faqs;